import { Tracker } from '@relewise/client';

import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig() || {};

const datasetId = publicRuntimeConfig?.RELEWISE_DATASET as string;
const url = publicRuntimeConfig?.RELEWISE_API_URL as string;
const authorization = publicRuntimeConfig?.RELEWISE_KEY as string;

export const relewiseTracker = datasetId && url && authorization
  ? new Tracker(datasetId, authorization, {
      serverUrl: url,
    })
  : null;